import styled from "styled-components";
import { useRouter } from "next/router";
import NextLink from "next/link";
import { FC } from "react";

const Page = styled.a<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: ${(props) => (props.active ? "#FFF1FB" : "#F3F7FD")};
  color: ${(props) => (props.active ? "#E271B6" : "#838D9B")};
  ${(props) => props.active && "border: 1px solid #E271B6"};
  margin: 0 8px;
  font-weight: 600;
  font-size: 14px;
  border: none;
  cursor: pointer;
  white-space: nowrap;
`;

const Dot = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: #838d9b;
`;

const Link: FC<{ page: number; active?: boolean }> = ({
  page,
  active,
  children,
}) => {
  const router = useRouter();
  return (
    <NextLink
      href={{
        pathname: router.pathname,
        query: { ...router.query, page },
      }}
      passHref
    >
      <Page active={active}>{children}</Page>
    </NextLink>
  );
};

const Dots = () => <Dot>•••</Dot>;

interface Props {
  currentPage: number;
  totalPages: number;
}

export const Pager = ({ currentPage, totalPages, ...rest }: Props) => {
  const prevPage = currentPage - 1;
  const nextPage = currentPage + 1;
  const afterNineteenPage = currentPage + 19;

  return (
    <div tw="flex-center" {...rest}>
      {currentPage > 1 && <Link page={prevPage}>{prevPage}</Link>}
      <Link page={currentPage} active>
        {currentPage}
      </Link>
      {currentPage < totalPages && (
        <Link page={nextPage}>
          <Page>{nextPage}</Page>
        </Link>
      )}
      {afterNineteenPage > totalPages ? (
        nextPage < totalPages && (
          <>
            <Dots />
            <Link page={totalPages}>{totalPages}</Link>
          </>
        )
      ) : (
        <>
          <Dots />
          <Link page={afterNineteenPage}>{afterNineteenPage}</Link>
          <Dots />
        </>
      )}
    </div>
  );
};
